import { c as _c } from "react/compiler-runtime";
import { Container } from "@opensea/ui-kit";
import { BackgroundOnly } from "./components/BackgroundOnly";
import { TextOnly } from "./components/TextOnly";
import { TextWithBackground } from "./components/TextWithBackground";
import { TextWithMedia } from "./components/TextWithMedia";

// Layout component props based on module fragment result

export function NarrativeModuleLayout(props) {
  const $ = _c(8);
  if (!props.variant) {
    return null;
  }
  switch (props.variant) {
    case "TEXT_AND_BACKGROUND":
      {
        let t0;
        if ($[0] !== props) {
          t0 = <TextWithBackground module={props} />;
          $[0] = props;
          $[1] = t0;
        } else {
          t0 = $[1];
        }
        return t0;
      }
    case "TEXT_AND_MEDIA":
      {
        let t0;
        if ($[2] !== props) {
          t0 = <TextWithMedia module={props} />;
          $[2] = props;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      }
    case "BACKGROUND":
      {
        let t0;
        if ($[4] !== props) {
          t0 = <BackgroundOnly module={props} />;
          $[4] = props;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        return t0;
      }
    case "TEXT":
      {
        let t0;
        if ($[6] !== props) {
          t0 = <Container className="py-(--overview-vertical-padding)"><TextOnly module={props} textContainerClassName="max-w-[var(--max-text-width)]" /></Container>;
          $[6] = props;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        return t0;
      }
    default:
      {
        return null;
      }
  }
}